import { render } from "./ContextMenuItem.vue?vue&type=template&id=50f1caf0&scoped=true&ts=true"
import script from "./ContextMenuItem.vue?vue&type=script&lang=ts"
export * from "./ContextMenuItem.vue?vue&type=script&lang=ts"

import "./ContextMenuItem.vue?vue&type=style&index=0&id=50f1caf0&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f1caf0"]])

export default __exports__